import { Typography, Box } from '@mui/material';
import { DATE_FORMAT } from '@ui-framework/index';

import dayjs from 'dayjs';

function splitCamelCaseAndCapitalize(str) {
  if (!str) return '';
  const withSpaces = str.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

function createdBy(original) {
  return `${original?.createdBy?.firstName || ''} ${original?.createdBy?.lastName || ''}`;
}

function auditData(original) {
  return original.auditData.map(row => (
    <Box key={row.newRecordVersion} mb={1}>
      <Typography variant="body2">
        <b>{splitCamelCaseAndCapitalize(row.field)}</b>:&nbsp;
        {row.oldValue !== undefined && row.oldDisplayValue === undefined && (
          <span style={{ color: 'gray', marginRight: 5 }}>
            Old: {String(row.oldValue) || '-'}{' '}
          </span>
        )}
        {row.oldDisplayValue !== undefined && (
          <span style={{ color: 'gray', marginRight: 5 }}>
            Old: {row.oldDisplayValue || '-'}{' '}
          </span>
        )}
        {row.newValue !== undefined && row.newDisplayValue === undefined && (
          <span style={{ color: '#009acd', marginRight: 5 }}>
            New: {String(row.newValue) || '-'}{' '}
          </span>
        )}
        {row.newDisplayValue !== undefined && (
          <span style={{ color: '#009acd' }}>
            New: {row.newDisplayValue || '-'}
          </span>
        )}
      </Typography>
    </Box>
  ));
}

function createdDateTime(original) {
  return original?.createdDateTime
    ? dayjs(original?.createdDateTime).format(DATE_FORMAT.LONG_DATE)
    : '';
}

export { auditData, createdBy, createdDateTime };
